import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { GetChangeStatus, GetOutletList, GetDeleteOutlet, ResendKitchenCredential, GetZatcaConfigurationsList, resetOutletBusinessDate } from '../../services/company_panel/outletService';
import Swal from 'sweetalert2'
import CustomPagination from '../../components/company_panel/common/custompagination'
import { capitalizeFirstLetter, formateDate, getBrandId } from '../../helpers/commonFunctions';
import Sorting from '../../components/company_panel/common/sorting';
import Loader from '../../components/company_panel/common/loader'
import StatusFilter from '../../components/company_panel/common/statusFilter'
import { showFilterlist } from '../../utils/Constants'
import CustomRangepicker from '../../components/company_panel/common/rangepicker'
import $ from "jquery";
import { getCompany, checkPermission } from '../../helpers/commonFunctions';
import notFound from '../../assets/company/img/no-record-found.png'
import { usePersistedListState } from '../../hooks/usePersistedListState';
import { generateZatcaPdf } from '../../helpers/zatcaPdf';
import { Modal, Button, Form } from 'react-bootstrap';
import CustomDatetimepicker from '../../helpers/customDatepicker';
import { useFormik } from 'formik';
import CustomDatetimepickerNew from '../../helpers/customDatePickerNew';

const OutletList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    // persisted filters (page lives in the route) — restored on return from add/edit/view
    const { saved, save, clear } = usePersistedListState('outlets');
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [showResetBusinessDateModal, setShowResetBusinessModal] = useState(false);
    const [originalResetDates, setOriginalResetDates] = useState({ business_date: null, inventory_date: null });
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [showZatcaModal, setShowZatcaModal] = useState(false);
    const [zatcaConfigList, setZatcaConfigList] = useState([]);
    const [zatcaConfigLoader, setZatcaConfigLoader] = useState(false);

    function handleChangeOutlet() {
        const evt = new CustomEvent('outlet-list-modified', { detail: {} });
        document.dispatchEvent(evt);
    }

    useEffect(() => {
        const onBrandChanged = () => setIsBrandChanged(prev => !prev);
        document.addEventListener('brand-changed', onBrandChanged);
        return () => document.removeEventListener('brand-changed', onBrandChanged);
    }, []);

    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('company_id', getCompany().company_id);
            formData.append('brand_id', getBrandId());
            GetOutletList(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                setLoader(false)
            }).catch(error => {
                console.log("error ====> ", error);
            })
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        $("#defaultstatus").prop("selectedIndex", 0)
        clear()
    }


    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData()
                formdata.append("id", row)
                GetDeleteOutlet(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'Outlet deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                        handleChangeOutlet()
                    }
                }).catch(error => {
                    console.log("deleteError", error)
                })
            }
        })
    }

    const ChangeStatus = (row, Num) => {
        const formData = new FormData()
        formData.append("id", row)
        formData.append("status", Num)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                GetChangeStatus(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                        handleChangeOutlet()
                    }
                }).catch(error => {
                    console.log("error===>", error)
                })
            }
        })
    }

    // resend outlet credentials
    const resendCredential = (row) => {
        const formData = new FormData()
        formData.append("id", row?.id)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Do you want to resend Credential?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ResendKitchenCredential(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                    }
                }).catch(error => {
                    console.log("error===>", error)
                })
            }
        })
    }

    const viewFunction = (row) => {
        navigate(`/company/business/outlet/${page}/view/${row}`)
    }

    const editFunction = (row) => {
        navigate(`/company/business/outlet/${params.id}/edit/${row.id}`, {
            state: {
                outletName: row?.outlet_name,
            },
        })
    }

    const copyOutletFunction = (row) => {
        navigate(`/company/business/outlet/${params.id}/edit/${row.id}?copy=true`);
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }
    // search or filer end

    const handleDownloadClick = (row) => {
        setShowZatcaModal(true);
        setZatcaConfigLoader(true);
        setZatcaConfigList([]);
        GetZatcaConfigurationsList({ outlet_id: row?.id }).then((data) => {
            setZatcaConfigList(data?.data?.response || []);
            setZatcaConfigLoader(false);
        })
        .catch((error) => {
            console.log("error===>", error);
            setZatcaConfigLoader(false);
        });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            outlet_id : '',
            business_date : '',
            inventory_date : ''
        },
        validate: values => {
            const errors = {};
            if (!values.business_date) errors.business_date = 'Business date is required';
            if (!values.inventory_date) errors.inventory_date = 'Inventory date is required';
            return errors;
        },
        onSubmit: values => {
            // globalLoader(true);
            if(!values?.business_date && !values?.inventory_date)return;

            let formData = new FormData();
            let hasChange = false;
            if (values?.business_date) {
                const businessDate = new Date(values.business_date);
                businessDate.setHours(0, 0, 0, 0);
                const originalBusiness = originalResetDates.business_date ? new Date(originalResetDates.business_date) : null;
                if (originalBusiness) originalBusiness.setHours(0, 0, 0, 0);
                if (!originalBusiness || businessDate.getTime() !== originalBusiness.getTime()) {
                    formData.append('business_date', businessDate.toISOString());
                    hasChange = true;
                }
            }
            if (values?.inventory_date) {
                const inventoryDate = new Date(values.inventory_date);
                inventoryDate.setHours(0, 0, 0, 0);
                const originalInventory = originalResetDates.inventory_date ? new Date(originalResetDates.inventory_date) : null;
                if (originalInventory) originalInventory.setHours(0, 0, 0, 0);
                if (!originalInventory || inventoryDate.getTime() !== originalInventory.getTime()) {
                    formData.append('inventory_date', inventoryDate.toISOString());
                    hasChange = true;
                }
            }
            if (!hasChange) return;
            formData.append('outlet_id', values.outlet_id);

            resetOutletBusinessDate(formData).then(response => {
                if (response?.data?.status === 1 || response?.data?.status === "1") {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'success',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500,
                        toast: true,
                        position: 'top-right',
                    });
                    formik.resetForm();
                    setShowResetBusinessModal(false);
                    handleChangeOutlet()
                    // globalLoader(false);
                } else {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 5000,
                        toast: true,
                        position: 'top-right',
                    })
                    // globalLoader(false);
                }
            }).catch(error => {
                console.log("error ====> ", error);
            })
        }
    });
    
    // same height and text size as the date fields in the Reset Outlet's Date modal
    const todayButtonStyle = { height: 'calc(2.25rem + 2px)', lineHeight: 1, padding: '0 14px', fontSize: '0.875rem' };

    const openResetBusinessDateModel = (outlet)=>{
        setShowResetBusinessModal(prev => !prev);
        console.log(outlet);
        formik.setFieldValue('outlet_id', outlet.id);
        // an unset date stays empty (new Date(null) would show 1970-01-01 and pass as filled)
        formik.setFieldValue('business_date', outlet.business_date ? new Date(outlet.business_date) : '');
        formik.setFieldValue('inventory_date', outlet.inventory_date ? new Date(outlet.inventory_date) : '');
        setOriginalResetDates({
            business_date: outlet.business_date ? new Date(outlet.business_date) : null,
            inventory_date: outlet.inventory_date ? new Date(outlet.inventory_date) : null,
        });
    }
    // console.log(formik.values);
    return (
        <>
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Outlets List</h4>
                    </div>

                    <div className='page-header-right ms-auto'>
                        {/* <a className="btn btn-primary mr-2" href={ZatcaSampleFileXlsx} download>
                            Sample Zatca Certificate <i class="fa fa-download" aria-hidden="true"></i>
                        </a> */}
                        {checkPermission('store_outlets', 'add') ?
                            <button className="btn btn-primary ms-2" onClick={() => navigate(`/company/business/outlet/${page}/add`)}>Create Outlet</button>
                            : ''}

                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} value={search.status === undefined ? '' : String(search.status)} />
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="12%">
                                            <div className='sorting_column'>
                                                <span>Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="outlet_name" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Name (Arabic) </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="outlet_name_ar" />
                                            </div>
                                        </th>
                                        <th width="11%">
                                            <span>Shortcode </span>
                                        </th>

                                        <th width="12%">
                                            <span>Brand</span>
                                        </th>
                                        <th width="12%">
                                            <span>Area</span>
                                        </th>
                                        <th width="13%">
                                            <div className='sorting_column'>
                                                <span>Created Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th width="7%">Status</th>
                                        <th className='action_head text-end' width="9%">Actions </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?

                                        <tr>
                                            <td colSpan={10}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr>
                                                    <td>{row?.id}</td>
                                                    <td>{capitalizeFirstLetter(row?.outlet_name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.outlet_name_ar)}</td>
                                                    <td >{row.short_code ? capitalizeFirstLetter(row?.short_code) : '-'}</td>
                                                    <td>{capitalizeFirstLetter(row?.brand_name)}</td>
                                                    <td>{row?.area_name ? capitalizeFirstLetter(row?.area_name) : '-'}</td>
                                                    <td>{row.created_at ? formateDate(row.created_at) : "N/A"}</td>
                                                    <td>
                                                        <div className="form-check form-switch w-25">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" for="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                {checkPermission('store_outlets', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { viewFunction(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                    : ''}
                                                                {checkPermission('store_outlets', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { editFunction(row) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                    : ''}
                                                                {checkPermission('store_outlets', 'delete') && row.slug != 'default' ?
                                                                    <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                    : ''}
                                                                {checkPermission('store_outlets', 'add') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy outlet</div></li>
                                                                    : ''}
                                                                <li><div className='dropdown-item' onClick={() => { resendCredential(row) }}><i className="ti ti-reload" aria-hidden="true"></i>Send Kitchen credential</div></li>
                                                                {Boolean(Number(row?.zatca_enabled)) ?
                                                                    <li><div className='dropdown-item' onClick={() => handleDownloadClick(row)}><i className="ti ti-download" aria-hidden="true"></i>Download Zatca Details</div></li>
                                                                    : ''}
                                                                <li>
                                                                    <div className='dropdown-item' onClick={() => {openResetBusinessDateModel(row);}}>
                                                                        <i className="ti ti-edit" aria-hidden="true"></i>Reset Business Date
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={10} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No records</p>
                                                </td>
                                            </tr>}</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: "/company/business/outlet/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>

            <Modal
                size="lg"
                show={showResetBusinessDateModal}
                onHide={() => {setShowResetBusinessModal(false); formik.resetForm();}}
                backdrop={true}
                className="modal-height-auto"
            >
                <Modal.Header className="text-white">
                    <Modal.Title>Reset Outlet's Date</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container overflow-auto" style={{ maxHeight: "70vh" }}>
                        
                        <div className='col-lg-6 text-center form-group mb-3'>
                            <label htmlFor='start_date' className='text-left d-flex'>Business Date :</label>
                            {/* Today fills the field; the submit sets it to midnight like any picked date.
                                The button takes the date field's height (the app's .btn is taller). */}
                            <div className='d-flex align-items-center gap-2'>
                                <div className='flex-grow-1'>
                                    <CustomDatetimepickerNew
                                        placeholder={"Reset Business Date"}
                                        setField={formik.setFieldValue}
                                        fieldname={`business_date`}
                                        setFieldTouched={formik.setFieldTouched}
                                        value={formik.values.business_date}
                                    />
                                </div>
                                <button type='button' className='btn btn-outline-primary text-nowrap' style={todayButtonStyle} onClick={() => formik.setFieldValue('business_date', new Date())}>Today</button>
                            </div>
                            <span className='text-danger d-flex text-left'>{formik.errors.business_date && formik.touched.business_date && formik.errors.business_date}</span>
                        </div>
                        <div className='col-lg-6 text-center form-group mb-3'>
                            <label htmlFor='start_date' className='text-left d-flex'>Inventory Date :</label>
                            <div className='d-flex align-items-center gap-2'>
                                <div className='flex-grow-1'>
                                    <CustomDatetimepickerNew
                                        placeholder={"Reset Inventory Date"}
                                        setField={formik.setFieldValue}
                                        fieldname={`inventory_date`}
                                        setFieldTouched={formik.setFieldTouched}
                                        value={formik.values.inventory_date}
                                    />
                                </div>
                                <button type='button' className='btn btn-outline-primary text-nowrap' style={todayButtonStyle} onClick={() => formik.setFieldValue('inventory_date', new Date())}>Today</button>
                            </div>
                            <span className='text-danger d-flex text-left'>{formik.errors.inventory_date && formik.touched.inventory_date && formik.errors.inventory_date}</span>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {setShowResetBusinessModal(false); formik.resetForm();}}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => {
                        formik.handleSubmit();
                    }}>
                        Reset
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                size="lg"
                show={showZatcaModal}
                onHide={() => { setShowZatcaModal(false); setZatcaConfigList([]); }}
                backdrop={true}
                className="modal-height-auto"
            >
                <Modal.Header className="text-white">
                    <Modal.Title>ZATCA Configurations</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container overflow-auto" style={{ maxHeight: "70vh" }}>
                        {zatcaConfigLoader ? (
                            <p className="text-center my-4">Loading...</p>
                        ) : zatcaConfigList && zatcaConfigList.length ? (
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Configuration Name</th>
                                        <th>Type</th>
                                        <th>Environment</th>
                                        <th>VAT Number</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {zatcaConfigList.map(cfg => (
                                        <tr key={cfg.id}>
                                            <td>{capitalizeFirstLetter(cfg.configuration_name) || 'N/A'}</td>
                                            <td>
                                                <span className={`badge ${cfg.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`}>
                                                    {cfg.configuration_type?.toUpperCase() || 'N/A'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`badge ${cfg.zatca_details?.zatca_environment_type === 'production' ? 'bg-success' : cfg.zatca_details?.zatca_environment_type === 'simulation' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                                    {cfg.zatca_details?.zatca_environment_type?.toUpperCase() || 'N/A'}
                                                </span>
                                            </td>
                                            <td>{cfg.zatca_details?.vat_number || 'N/A'}</td>
                                            <td className="text-center">
                                                <button type="button" className="btn btn-sm btn-primary" onClick={() => generateZatcaPdf(cfg)}>
                                                    <i className="ti ti-download" aria-hidden="true"></i> Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center my-4">
                                <img src={notFound} style={{ width: "10%" }} alt="Not Found" />
                                <p>No ZATCA configurations found for this outlet</p>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowZatcaModal(false); setZatcaConfigList([]); }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
}

export default OutletList